var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      staticClass: "form_wrapper",
      attrs: { width: "700px", title: _vm.title, confirmLoading: _vm.loading },
      on: { ok: _vm.handleConfirm },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "a-form-model",
        _vm._b(
          { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
          "a-form-model",
          _vm.formLayout,
          false
        ),
        [
          _c(
            "a-form-model-item",
            { attrs: { prop: "type", label: "测线类型" } },
            [
              _c("EnumSelector", {
                attrs: {
                  enumConfig: _vm.LINE_TYPE_ENUM,
                  placeholder: "请选择测线类型",
                },
                model: {
                  value: _vm.form.type,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "type", $$v)
                  },
                  expression: "form.type",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { prop: "number", label: "测线序号" } },
            [
              _c("a-input", {
                staticStyle: { width: "100%" },
                attrs: {
                  type: "number",
                  placeholder: "请输入测线序号",
                  min: 1,
                },
                model: {
                  value: _vm.form.number,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "number", $$v)
                  },
                  expression: "form.number",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { prop: "distance", label: "距离墙头（米）" } },
            [
              _c("PriceInput", {
                attrs: { placeholder: "请输入距离墙头距离" },
                model: {
                  value: _vm.form.distance,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "distance", $$v)
                  },
                  expression: "form.distance",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }